import * as React from 'react';

import { Button, LinkButton } from '@travelnest/merlin.button';
import theme from '@travelnest/merlin.theme';
import { FeaturedContainer } from '../../components/featured-container/FeaturedContainer';

const presetTheme = <C extends React.FC, P extends React.ComponentProps<C>, T extends Partial<P>>
	(component: C, presets: T) => (props: Omit<P, keyof T>) => component({ ...presets, ...props });

export const BlueButton = presetTheme(Button, { bgColor: theme.colours.primary.default, color: theme.colours.text.white });
export const BlueLinkButton = presetTheme(LinkButton, { bgColor: theme.colours.primary.default, color: theme.colours.text.white });

export const GreyButton = presetTheme(Button, { bgColor: theme.colours.neutral.light, color: theme.colours.text.darkest });
export const GreyLinkButton = presetTheme(LinkButton, { bgColor: theme.colours.neutral.light, color: theme.colours.text.darkest });

const HELP_LINK = 'https://travelnest.freshdesk.com/support/solutions/articles/101000362818-logging-in-to-your-travelnest-account';

export const HelpFeaturedContainer: React.FC<React.PropsWithChildren> = ({ children }) => {
	return <FeaturedContainer rightHandContent={<GreyLinkButton to={HELP_LINK}>Help</GreyLinkButton>}>
		{children}
	</FeaturedContainer>;
};

export const ErrorMessage: React.FC<React.PropsWithChildren> = ({ children }) => {
	const style = {
		marginTop: theme.layout.spacing.standard,
		background: theme.colours.error.tint,
		color: theme.colours.error.primary,
		padding: theme.layout.spacing.smaller
	};
	return <p className="error-message" style={style}>
		{children}
	</p>;
};
